import { Anchor, Box, Container, Group, Stack, Text, Title } from "@mantine/core";
import { type FC } from "react";

import AppSettings from "src/AppSettings";
import TrogLogo from "src/assets/img/trog_logo.png";
import Icon from "src/components/common/Icon";
import useCurrentUser from "src/hooks/authentication/useCurrentUser";

import { PreferencesAction, ReportBugAction } from "../shared/HeaderActions";

/**
 * Defines the inputs for this navigation presentation.
 */
interface IHeaderProps {}

/**
 * Renders TROG branding and the current user's account actions.
 *
 * Postconditions: Authenticated users see preferences and logout; absent users receive a login
 * link carrying the current pathname and query. Bug-report visibility follows application settings.
 */
const Header: FC<IHeaderProps> = () => {
    const user = useCurrentUser();

    return (
        <Box>
            <Container size="xl">
                <Group
                    gap="md"
                    justify="space-between"
                >
                    <Box py="md">
                        <a
                            href="https://www.trog.com.au/"
                            className="no-mobile"
                        >
                            <img
                                src={TrogLogo}
                                width={80}
                            />
                        </a>
                    </Box>
                    <Stack
                        py="md"
                        gap="xs"
                        justify="center"
                        align="flex-end"
                    >
                        <Title
                            fw="bold"
                            c="primary"
                            component="div"
                            order={2}
                        >
                            Trial Management
                        </Title>
                        <Box>
                            {user ? (
                                <Group gap="xs">
                                    <Text fw="bold">{user.fullName}</Text>
                                    <Box>|</Box>
                                    <PreferencesAction />
                                    {AppSettings.sentry.enableReportABug && <Box>|</Box>}
                                    <ReportBugAction />
                                    <Box>|</Box>
                                    <Anchor href="/auth/logout">
                                        Logout <Icon icon={AppSettings.icons.logout} />
                                    </Anchor>
                                </Group>
                            ) : (
                                <Anchor
                                    href={
                                        "/auth/openiddict?ReturnUrl=" +
                                        encodeURIComponent(
                                            window.location.pathname + window.location.search
                                        )
                                    }
                                    className=""
                                >
                                    Login <Icon icon={AppSettings.icons.login} />
                                </Anchor>
                            )}
                        </Box>
                    </Stack>
                </Group>
            </Container>
        </Box>
    );
};

export default Header;
